import React from "react";
import InitialPropsContext from "../lib/models/initialPropsContext";
// import getAPIUrl from "../../lib/getAPIUrl";
// import SectionList, { SectionWithId } from "../components/sections/SectionList";
import PageProps from "../lib/models/pageProps";
import SectionListNachhaltigkeiten, {
  SectionWithId
} from "../components/sections/SectionListNachhaltigkeiten";

export default function Page(props: { contents: SectionWithId[] }) {
  return (
    <SectionListNachhaltigkeiten
      sections={props.contents}
      sectionBackgroundColor={true}
    />
  );
}

Page.getInitialProps = async ({
  api
}: InitialPropsContext): PageProps<{ contents: SectionWithId[] }> => {
  const pageContents = await api.loadNachhaltigkeit().catch(() => ({
    total: 0,
    NachhaltigkeitSlider: { sliderItems: [] },
    contents: [],
    message: "Bad request"
  }));

  const contents: SectionWithId[] | [] = [...pageContents.contents];
  const nachhaltigkeitSlider = pageContents.NachhaltigkeitSlider;

  if (nachhaltigkeitSlider && nachhaltigkeitSlider.sliderItems.length !== 0) {
    contents.splice(0, 0, {
      ...nachhaltigkeitSlider,
      _type: "NachhaltigkeitSlider" as const
    });
  }
  let _pageImages;
  try {
    _pageImages = SectionListNachhaltigkeiten.getImages({ sections: contents });
  } catch (error) {
    console.error(error);
  }

  return {
    contents,
    _pageImages
  };
};
